import React from 'react';
import styles from './MetaLabel.module.css';

interface MetaLabelProps {
    status: string;
    label: string;
}

const getStatusClassName = (status: string) => {
    switch (status.toLowerCase()) {
    case 'active':
        return styles.status__active;
    case 'inactive':
        return styles.status__inactive;
    case 'archived ':
        return styles.status__archived;
    case 'nooffers':
        return styles.zero__offers;
    case 'hasoffers':
        return styles.has__offers;
    case 'inprogress':
        return styles.status__progress;
    case 'deleted':
    default:
        return styles.status__default;
    }
};

const MetaLabel: React.FC<MetaLabelProps> = ({ status, label }) => (
    <span className={`${styles.status} ${getStatusClassName(status)}`}>
        {label}
    </span>
);

export default MetaLabel;